export default __webpack_public_path__ + "c15c775150b40557c603902d757e1f00.png";